import { Link } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import { Empty } from "../kit";
import { rupiah, fmtDate } from "../../lib/constants";

const INCOME_COLS = ["Tanggal", "No. Order", "Pelanggan", "Keterangan", "Metode", "Nominal", "Oleh"];
const RECV_COLS = ["No. Order", "Pelanggan", "Deadline", "Status", "Total", "Dibayar", "Sisa"];
const EXP_COLS = ["Tanggal", "Kategori", "Supplier", "Keterangan", "Metode", "Nominal", ""];

const Method = ({ m }) => <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-700 text-xs font-bold">{m || "Tunai"}</span>;
const orderLink = (r) => <Link to={`/order/${r.order_id}`} className="font-mono font-bold text-sky-600" data-testid={`fin-order-${r.order_no}`}>{r.order_no}</Link>;

export function Table({ cols, rows, testid }) {
  if (!rows.length) return <Empty text="Tidak ada data." data-testid={`${testid}-empty`} />;
  return (
    <div className="overflow-x-auto bg-white rounded-2xl border border-slate-200" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="bg-slate-900 text-white"><tr>{cols.map((c, j) => <th key={c || `c${j}`} className="px-3 py-3 text-left font-bold whitespace-nowrap">{c}</th>)}</tr></thead>
        <tbody>{rows.map(([key, ...r]) => <tr key={key} className="border-t border-slate-100 even:bg-slate-50">{r.map((v, j) => <td key={cols[j] || `c${j}`} className="px-3 py-2.5 whitespace-nowrap">{v}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}

export function IncomeTable({ rows }) {
  return <Table testid="fin-income-table" cols={INCOME_COLS}
    rows={rows.map((r, i) => [`${r.order_id}-${r.date}-${i}`, fmtDate(r.date), orderLink(r), r.customer, r.note, <Method key="m" m={r.method} />, <span key="amt" className="font-mono font-bold text-emerald-700">{rupiah(r.amount)}</span>, r.by_name])} />;
}

export function ReceivableTable({ rows }) {
  return <Table testid="fin-receivable-table" cols={RECV_COLS}
    rows={rows.map((r) => [r.order_id, orderLink(r), r.customer, fmtDate(r.deadline), r.status, rupiah(r.total), rupiah(r.paid), <span key="rem" className="font-mono font-bold text-rose-600">{rupiah(r.remaining)}</span>])} />;
}

export function ExpenseTable({ rows, byCategory, onEdit, onDelete }) {
  return (
    <>
      {Object.keys(byCategory).length > 0 && (
        <div className="flex flex-wrap gap-2 text-xs" data-testid="fin-expense-categories">
          {Object.entries(byCategory).map(([k, v]) => <span key={k} className="px-3 py-1.5 rounded-full bg-slate-100 font-semibold">{k}: <span className="font-mono">{rupiah(v)}</span></span>)}
        </div>
      )}
      <Table testid="fin-expense-table" cols={EXP_COLS}
        rows={rows.map((e) => [e.id, fmtDate(e.date), e.category, e.supplier || "-", <span key="d">{e.description}{e.note && <span className="text-slate-400"> · {e.note}</span>}</span>,
          <Method key="m" m={e.method} />,
          <span key="a" className="font-mono font-bold text-rose-600">{rupiah(e.amount)}</span>,
          <span key="x" className="flex gap-1"><button onClick={() => onEdit(e)} className="h-9 w-9 grid place-items-center rounded-lg bg-slate-100" data-testid={`edit-expense-${e.id}`}><Pencil className="w-4 h-4" /></button><button onClick={() => onDelete(e)} className="h-9 w-9 grid place-items-center rounded-lg bg-rose-50 text-rose-600" data-testid={`delete-expense-${e.id}`}><Trash2 className="w-4 h-4" /></button></span>])} />
    </>
  );
}
